import { TradingOffer } from 'types/TradingOffer';

const getOfferReference = (offer: TradingOffer | null): string => {
  if (!offer) return '';
  const typePrefix = offer.type === 'SELL' ? 'OFV' : 'OFC';
  const year = new Date(offer.createdAt).getFullYear();
  const idSuffix = offer._id.slice(-6).toUpperCase();
  return `#${typePrefix}-${year}-${idSuffix}`;
};

export default getOfferReference;
